import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, CommodityDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
export const EditMasterQuantity = withRouter(props => {

  const classes = useStyles();
  const [commodityobj, setCommodityobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const [masters, setMasters] = useState({
    commodity : []
  });
  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };


  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/fetchbuycommodity', {}, {},false)
    setMasters({
      ...masters,
      commodity : commodities
    })
   
  }
  async function updatecommodity(commodityinfo)
  {
  // alert(JSON.stringify(commodityinfo))
  setOpen(!open);
    let commodities = await sendNetworkRequest('/addquantity', {}, commodityinfo,false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: commodities.status,
      msg: commodities.message,
      vertical: "top",
    });
    setOpen(false);


  }
  async function fetchcommodityinfo(commodityid)
  {
    let commodities = await sendNetworkRequest('/fetchbuycommodityinfo', {}, {commodityID : commodityid},false)
    let commodity ={}
    if(commodities && commodities.parent_commodity)
    {
      commodity = {
        value : commodities.parent_commodity.id,
        label : commodities.parent_commodity.name
      }
    }else
    {
      commodity = {
        value : commodities.id,
        label : commodities.name
      }
    }
    setCommodityobj({
      ...commodities,
      commodity
    })
   
  }
  useEffect(() => {
     var com_id = props.location.pathname.split('/')[2];
    if(com_id)
    {
      fetchcommodityinfo(com_id);
    }
    
    fetchmasters()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
    <CommodityDetails usercontent={commodityobj} masters={masters} viewtype={viewtype} onSave={updatecommodity}/>
    <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Page>
  );
});

export default EditMasterQuantity;
